module.exports = __webpack_public_path__ + "media/images/CertificationSchemeStandards-ddb09c086c6726937efa445d104100da.svg";